<template>
  <div>
    <gui-select
        :modelValue="modelValue"
        @update:modelValue="e=>$emit('update:modelValue', e)"
        :label="label"
        :error="error"
        :hilightOn="hilightOn"
        :w="w"
        :sm="sm"
        :edit="edit"
        :list="list">
      <option value="" disabled>Тип вопроса</option>
    </gui-select>
  </div>
</template>

<script>
export default {
  name: 'gui-quiz-question-type-select',
  data() {
    return {
      list: [],
    }
  },
  props: {
    label: String,
    error: [String, Object, Array],
    hilightOn: [Array, String, Number],
    modelValue: {
      type: [String, Number],
    },
    w: Boolean,
    sm: Boolean,
    edit: {
      type: Boolean,
      default: true
    },
  },
  mounted() {
    this.loadList();
  },
  methods: {
    loadList() {
      axiosGetValue('/api/admin/quiz-question-type/widget', {}, e => {
        this.list = e
      })
    },
  }
}
</script>